// extracted by mini-css-extract-plugin
module.exports = {"follow":"e_vQ","button":"e_wQ","note":"e_xQ","error":"e_yQ"};